module.exports = __webpack_public_path__ + "img/mess_user.250f44b4.svg";